<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "FolderPosition",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.FOLDERS,
    displayName: "Position in Parent Folder",
    displayIcon: "material-symbols:format-list-numbered",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [StoryPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    // The mirror of the in-folder counts: this is the story's place WITHIN its
    // parent, so it only means anything for a story that sits in a folder. A
    // top-level story has no position and would otherwise render a bare "0".
    // Gated on myFolder rather than isFolder — a nested folder is itself a
    // folder AND has a position among its siblings. Kept visible on the canvas
    // so it can still be selected and designed.
    shouldShowText() {
      return this.editMode || this.entity.myFolder > 0;
    },
    value() {
      return String(this.entity.folderPosition);
    },
  },
};
</script>
